// src/services/uploadHelper.js
// Upload de arquivos via Supabase Storage — substitui o upload.php do Hostgator

const SUPABASE_URL = 'https://wlbafvaftkklhukycjpp.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndsYmFmdmFmdGtrbGh1a3ljanBwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODkyMjQ1MDIsImV4cCI6MjEwNDgwMDUwMn0.ESNkPFsVVFe1XscEhjQ12e0FHe1kv4I5j1YR4GPFOyc';
const BUCKET = 'paroquia-uploads';

// Gera nome único para o arquivo
const nomeUnico = (arquivo) => {
  const ext  = arquivo.name.split('.').pop();
  const base = arquivo.name.replace(/\.[^/.]+$/, '').replace(/[^a-z0-9]/gi, '_').slice(0, 30);
  const ts   = Date.now();
  return `${base}_${ts}.${ext}`;
};

// Upload de um único arquivo
// pasta: ex. 'batismo/TurmaJunho', 'noivos/TurmaSetembro'
export const uploadArquivo = async (arquivo, pasta = 'geral') => {
  if (!arquivo) return '';

  const caminho = `${pasta}/${nomeUnico(arquivo)}`;

  const res = await fetch(
    `${SUPABASE_URL}/storage/v1/object/${BUCKET}/${caminho}`,
    {
      method: 'POST',
      headers: {
        'apikey':        SUPABASE_KEY,
        'Authorization': `Bearer ${SUPABASE_KEY}`,
        'Content-Type':  arquivo.type,
        'x-upsert':      'false',
      },
      body: arquivo,
    }
  );

  if (!res.ok) {
    const err = await res.text();
    throw new Error(`Erro no upload: ${err}`);
  }

  // Retornar URL pública
  return `${SUPABASE_URL}/storage/v1/object/public/${BUCKET}/${caminho}`;
};

// Upload de múltiplos arquivos — retorna array de URLs
export const uploadMultiplos = async (arquivos, pasta = 'geral') => {
  if (!arquivos || arquivos.length === 0) return [];
  const urls = await Promise.all(
    Array.from(arquivos).map(arq => uploadArquivo(arq, pasta))
  );
  return urls.filter(Boolean);
};
